import axios from "axios";
const ServiceURL = process.env.VUE_APP_SERVICEURL;

export default {
  name: "alokasiManager",
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getAlokasiManager(store) {
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: ServiceURL + "rekap_alokasi_manager",
          params: {
            tlc: store.rootState.auth.auth.username
          },
          auth: {
            username: store.rootState.auth.auth.username,
            password: store.rootState.auth.auth.password
          },
          headers: {
            "X-API-KEY": store.rootState.auth.auth.apikey
          }
        })
          .then(response => {
            resolve(response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getPeriode(store) {
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: ServiceURL + "rekap_alokasi_manager/master",
          auth: {
            username: store.rootState.auth.auth.username,
            password: store.rootState.auth.auth.password
          },
          headers: {
            "X-API-KEY": store.rootState.auth.auth.apikey
          }
        })
          .then(response => {
            resolve(response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    newAlokasiManager(store, payload) {
      return new Promise((resolve, reject) => {
        axios({
          method: "post",
          url: ServiceURL + "rekap_alokasi_manager",
          data: {
            tlc: store.rootState.auth.auth.username,
            deskripsi: payload.description
          },
          auth: {
            username: store.rootState.auth.auth.username,
            password: store.rootState.auth.auth.password
          },
          headers: {
            "X-API-KEY": store.rootState.auth.auth.apikey
          }
        })
          .then(response => {
            resolve(response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  }
};
